import { type Directive } from 'vue';

const createTooltip = () => {
  const _tooltip = document.createElement('div');

  _tooltip.className = 'tooltip';
  _tooltip.innerText = 'tip';
  _tooltip.style.position = 'fixed';
  _tooltip.style.backgroundColor = '#333';
  _tooltip.style.color = '#fff';
  _tooltip.style.padding = '5px 10px';
  _tooltip.style.borderRadius = '4px';
  _tooltip.style.fontSize = '12px';
  _tooltip.style.whiteSpace = 'nowrap';
  _tooltip.style.zIndex = '1000';
  _tooltip.style.opacity = '0';
  _tooltip.style.transition = 'opacity 0.2s ease';
  _tooltip.style.pointerEvents = 'none';

  document.body.appendChild(_tooltip);

  return _tooltip;
}

const tooltip: HTMLElement | null = createTooltip();
let currentTarget: HTMLElement | null = null;

const showTooltip = (event: MouseEvent, binding: any) => {
  tooltip.innerText = binding.value || '';

  if (!tooltip.innerText || tooltip.innerText == '') {
    hideTooltip();
    return;
  }

  const element = event.target as HTMLElement;
  currentTarget = element;

  updatePosition(element);

  tooltip.style.visibility = 'visible';
  tooltip.style.opacity = '1';
};

const hideTooltip = () => {
  tooltip.style.opacity = '0';
}

const updatePosition = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect();

  tooltip.style.top = `${rect.bottom + window.scrollY + 5}px`;
  tooltip.style.left = `${rect.left + window.scrollX + rect.width / 2 - tooltip.offsetWidth / 2}px`;

  const tooltipRect = tooltip.getBoundingClientRect();

  if (tooltipRect.left < 0) {
    tooltip.style.left = `${rect.left + window.scrollX}px`;
  }
  if (tooltipRect.right > window.innerWidth) {
    tooltip.style.left = `${rect.right + window.scrollX - tooltip.offsetWidth}px`;
  }
  if (tooltipRect.bottom > window.innerHeight) {
    tooltip.style.top = `${rect.top + window.scrollY - tooltip.offsetHeight - 5}px`;
  }
}

export const vTooltip: Directive = {
  mounted(el, binding) {
    const onMouseEnter = (event: MouseEvent) => showTooltip(event, binding);

    el.addEventListener('mouseenter', onMouseEnter);
    el.addEventListener('mouseleave', hideTooltip);

    el._tooltip = { onMouseEnter };
  },

  updated(el, binding) {
    const onMouseEnter = (event: MouseEvent) => showTooltip(event, binding);

    el.removeEventListener('mouseenter', el._tooltip.onMouseEnter);
    el.addEventListener('mouseenter', onMouseEnter);

    if (currentTarget === el) tooltip.innerText = binding.value || '';
  },

  unmounted(el) {
    const { onMouseEnter } = el._tooltip || {};

    el.removeEventListener('mouseenter', onMouseEnter);
    el.removeEventListener('mouseleave', hideTooltip);

    hideTooltip();

    delete el._tooltip;
  }
};